/**
 * Plan-driven shell mode (DSP vs one-page DWM). Shared by layout and nav helpers.
 */
export interface PlanUiAuth {
  user?: {
    primaryMember?: {
      plan?: {
        isDsp?: boolean;
        isDwm?: boolean;
      };
    };
    associatedMembers?: unknown[];
  };
}

function associatedMembersCount(auth: PlanUiAuth): number {
  return auth.user?.associatedMembers?.length ?? 0;
}

/**
 * Returns true if app should use DSP UI.
 * DSP UI should be used if plan is DSP, or plan is DWM and there are one or more associated members.
 */
export function shouldUseDspUi(auth: PlanUiAuth): boolean {
  const isDsp = auth.user?.primaryMember?.plan?.isDsp ?? false;
  const isDwm = auth.user?.primaryMember?.plan?.isDwm ?? false;
  return isDsp || (isDwm && associatedMembersCount(auth) > 0);
}

/**
 * Returns true if app should use DWM UI.
 * DWM UI should be used if plan is DWM and there are no associated members.
 */
export function shouldUseDwmUi(auth: PlanUiAuth): boolean {
  const isDwm = auth.user?.primaryMember?.plan?.isDwm ?? false;
  return isDwm && associatedMembersCount(auth) === 0;
}
